import styled from 'styled-components';

export const Body = styled.div`
  transition-property: all;
  transition-timing-function: ease-in-out;
  overflow: hidden;
`;
